export default __webpack_public_path__ + "static/media/hanukkah-appbar-tile.f73f6845.png";